import React from "react";
import { string, node, oneOfType, arrayOf, objectOf, oneOf, number } from "prop-types";
import cx from "classnames";
import { camel } from "case";
import { findByType } from "../util/findByType";
// eslint-disable-next-line import/no-cycle
import { Link as LinkComponent } from "../Link";
import { Icon } from "../../components/Icons";
import { Img } from "../Images";
import * as styles from "./IconLinks.module.scss";

const Image = () => null;
Image.displayName = "IconLinksImage";
const Title = () => null;
Title.displayName = "IconLinksTitle";
const Content = () => null;
Content.displayName = "IconLinksContent";
const Pricing = () => null;
Pricing.displayName = "IconLinksPricing";

const IconLinks = ({ children, style, className, layout, to, target }) => {
	const renderIcon = () => {
		const icon = findByType(children, Icon);
		if (!icon) {
			return null;
		}

		return (
			<Icon name={icon.props.icon} className={`${icon.props.icon.size} ${icon.props.className}`} />
		);
	};
	const renderImage = () => {
		const image = findByType(children, Image);
		if (!image) {
			return null;
		}
		return (
			<div style={image.props.style} className={image.props.className}>
				<Img src={image.props.url} />
			</div>
		);
	};

	const renderTitle = () => {
		const title = findByType(children, Title);
		if (!title) {
			return null;
		}
		return <span className={title.props.className}>{title.props.children}</span>;
	};
	const renderContent = () => {
		const content = findByType(children, Content);
		if (!content) {
			return null;
		}
		return <div className={content.props.className}>{content.props.children}</div>;
	};

	const renderPricing = () => {
		const pricing = findByType(children, Pricing);

		if (!pricing) {
			return null;
		}

		return <div className={pricing.props.className}>{pricing.props.children}</div>;
	};

	return to ? (
		<LinkComponent
			className={cx(styles.iconLinks, styles.link, className)}
			style={style}
			to={to}
			target={target}>
			{renderIcon()}
			{renderImage()}
			{renderTitle()}
			{renderContent()}
			{renderPricing()}
		</LinkComponent>
	) : (
		<div
			className={cx(styles.iconLinks, className, {
				[styles[camel(layout)]]: layout && styles[camel(layout)],
			})}
			style={style}>
			{renderIcon()}
			{renderImage()}
			{renderTitle()}
			{renderContent()}
			{renderPricing()}
		</div>
	);
};

IconLinks.Icon = Icon;
IconLinks.Title = Title;
IconLinks.Content = Content;
IconLinks.Image = Image;
IconLinks.Pricing = Pricing;

IconLinks.propTypes = {
	children: oneOfType([arrayOf(node), node]).isRequired,
	className: string,
	style: objectOf(oneOfType([string, number])),
	layout: oneOf(["row", "row-reverse", "stack", "stack-reverse"]),
	to: string,
	target: string,
};
IconLinks.defaultProps = {
	className: "",
	style: {},
	layout: "stack",
	to: null,
	target: null,
};

export default IconLinks;
export { IconLinks };
